import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./translations/en";
import { tr } from "./translations/tr";

let savedLanguage = "en";

if (typeof window !== "undefined") {
  savedLanguage = localStorage.getItem("i18nextLng") || "en";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    tr: { translation: tr },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;

